import React from 'react';
import styles from './orderModalContainer.scss';
import { IInjectedProps, ITakeAwayArticleTrackingData } from '../../../types';
import LoadingSpinner from '../loadingSpinner/loadingSpinner';
import OrderModalDataProvider from '../orderModalDataProvider/orderModalDataProvider';
import { IOrderModalContainer } from './orderModalContainer.d';

export const OrderModalContainer = (props: IInjectedProps & IOrderModalContainer & ITakeAwayArticleTrackingData) => {
    const { isOpen, isError, isLoading, initialData, initialScrollPosition, handleIsOpenChange, itemOrigin,
        magicLink, enabledClientLogging, contentContainerId, viewType, slidingOut, productRecommendationFragment,
        productRecommendationModel, productRecommendationTileIndex } = props;

    if (!isOpen || isError) {
        return null;
    }

    if (isLoading && !initialData) {
        return <LoadingSpinner />;
    }

    return (
        <div data-testid='order_modal' data-semantic-id='order_modal' className={styles.order_modal}>
            <div className={styles.order_modal_container}>
                <OrderModalDataProvider
                    isLoading={isLoading}
                    initialData={initialData}
                    initialScrollPosition={initialScrollPosition}
                    handleIsOpenChange={handleIsOpenChange}
                    itemOrigin={itemOrigin}
                    magicLink={magicLink}
                    enabledClientLogging={enabledClientLogging}
                    contentContainerId={contentContainerId}
                    viewType={viewType}
                    slidingOut={slidingOut}
                    productRecommendationFragment={productRecommendationFragment}
                    productRecommendationModel={productRecommendationModel}
                    productRecommendationTileIndex={productRecommendationTileIndex}
                />
            </div>
        </div>
    );
};

export default OrderModalContainer;

